import ColetaRepository from "../repository/coleta_repository";

class ColetaService {
	constructor() {
		this.repository = new ColetaRepository();
	}

	async save(data) {
		return this.repository.save(data);
	}

	async update(data) {
		return this.repository.update(data);
	}

	async getColetasPorData(unidadeDistribuidoraId, data, page = 1, limit = 50, search = "") {
		return this.repository.getColetasPorData(unidadeDistribuidoraId, data, page, limit, search);
	}

	async getColetasAgrupadasPorFornecedor(unidadeDistribuidoraId, data) {
		return this.repository.getColetasAgrupadasPorFornecedor(unidadeDistribuidoraId, data);
	}

	async getEstatisticas(unidadeDistribuidoraId, data) {
		return this.repository.getEstatisticas(unidadeDistribuidoraId, data);
	}

	async getResumoSemanal(unidadeDistribuidoraId) {
		return this.repository.getResumoSemanal(unidadeDistribuidoraId);
	}

	async getById(id) {
		return this.repository.getById(id);
	}

	async getRetificacoesNaoVistas(unidadeDistribuidoraId) {
		const res = await this.repository.getRetificacoesNaoVistas(unidadeDistribuidoraId);
		return res.data || [];
	}

	async marcarRetificacoesVistas(unidadeDistribuidoraId, ids) {
		const res = await this.repository.marcarRetificacoesVistas(unidadeDistribuidoraId, ids);
		// Avisa o menu: o badge de Coletas vive no AppSidebar, que só recarrega na navegação.
		window.dispatchEvent(new Event("retificacoes-atualizadas"));
		return res.data;
	}

	async confirmar(id) {
		return this.repository.confirmar(id);
	}

	async cancelar(id) {
		return this.repository.cancelar(id);
	}

	async changeVisibility(id) {
		return this.repository.changeVisibility(id);
	}
}

export default ColetaService;
